import { makeAutoObservable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

class ContextCollectionStore {
  showContextHelper = true;

  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: 'contextCollectionStore',
      properties: ['showContextHelper'],
      storage: window.localStorage,
    });
  }

  setShowContextHelper(v: boolean) {
    this.showContextHelper = v;
  }
}

export const contextCollectionStore = new ContextCollectionStore();

export const useShowContextHelper = () =>
  contextCollectionStore.showContextHelper;
export const setShowContextHelper = (show: boolean) =>
  contextCollectionStore.setShowContextHelper(show);
